import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'
import {getLoginId} from '../../functions/Common.js'

// 发布朋友圈，保存朋友圈信息
export function webMomentsSave(sendData,custom_id,open_id,callback){
	request({
			method: 'post',
			url: 'monents/save',
			data: {
			  manage_id: getLoginId(),
			  custom_id:custom_id,
			  open_id: open_id,
			  content: sendData.content,
			  cover: sendData.cover,
			  url: sendData.url,
			  url_content: sendData.urlContent,
			  img_url: sendData.imgUrl instanceof Array ? sendData.imgUrl.join(',') : sendData.imgUrl,
			  auth:sendData.auth !== undefined ? JSON.stringify(sendData.auth):  JSON.stringify([]),
			  remindFans:sendData.remindFans !== undefined ? JSON.stringify(sendData.remindFans):  JSON.stringify([]),
			  comment:sendData.comment !== undefined ? JSON.stringify(sendData.comment):  JSON.stringify([]),
			  qq_maps:sendData.qq_maps !== undefined ? JSON.stringify(sendData.qq_maps):  JSON.stringify({}),
			  type: sendData.type !== undefined ? sendData.type : 1
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data.id)
		}else{
			callback(0)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 保存朋友圈评论信息
export function webMomentsReplySave(data,callback){
	request({
			method: 'post',
			url: 'monents/saveReply',
			data: {
			  account_open_id: data.account_open_id !== undefined ? data.account_open_id: '',
			  account_sns_id: data.account_sns_id !== undefined ? data.account_sns_id: '',
			  account_comment_id: data.account_comment_id !== undefined ? data.account_comment_id: '0',
			  account_name: data.account_name !== undefined ? data.account_name: '',
			  content: data.content !== undefined ? data.content: '',
			  friend_open_id: data.friend_open_id !== undefined ? data.friend_open_id: '',
			  friend_name: data.friend_name !== undefined ? data.friend_name: '',
			  argued_open_id: data.argued_open_id !== undefined ? data.argued_open_id: '',
			  argued_name: data.argued_name !== undefined ? data.argued_name: '',
			  moment: data.moment !== undefined ? data.moment : '{}'
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(true)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 获取点赞和评论的数据，包括点赞数，评论数据，最有一次点赞的时间，最后一次评论的时间
export function webGetMomentZCData(fans_wxid,callback){
	request({
			method: 'post',
			url: 'monents/getZCData',
			data: {
				fans_wxid: fans_wxid
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

/**
 * 根据客服wxid获取数据库客服已发的朋友圈列表
 * @param {Object} wxid
 * @param {Object} firstId
 * @param {Object} callback
 */
export function webGetMomentList(wxid,firstId,callback){
	request({
			method: 'post',
			url: 'monents/getList',
			data: {
				wxid: wxid,
				firstId:firstId
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

/**
 * 根据snsId，获取评论列表
 * @param {Object} snsId
 * @param {Object} callback
 */
export function webGetMomentReplyList(snsId,callback){
	request({
			method: 'post',
			url: 'monents/getReplyList',
			data: {
				snsId: snsId
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 获取当前管理员下的未读评论信息
export function webGetMomentReplyNoReadList(callback){
	request({
			method: 'post',
			url: 'monents/getReplyNoReadList',
			data: {
				manage_id: getLoginId()
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 更新消息为已读
export function webMomentsAllRead(callback){
	request({
			method: 'post',
			url: 'monents/updateAllRead',
			data: {
			  manage_id: getLoginId(),
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(true)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}